import axios from 'axios';
import endpoints from '../../endpoints';
import {handleError, handleRawResponse} from './apiUtils';

export function createContract(params) {
    const url = endpoints.contract;

    return axios.post(url, params)
        .then(handleRawResponse) // needed to get custom headers
        .catch(handleError);
}

export function viewContract(params) {
    const url = endpoints.contractView;

    return axios.post(url, params)
        .then(handleRawResponse) // needed to get custom headers
        .catch(handleError);
}
